// init object
he.googleMaps = {
    map: undefined,
    infoWindow: undefined,
    service: undefined,
    markers: [],
    // define vars needed by api
    mapHtmlElement: 'map-canvas',
    placeIds: [],
};


// define map options
he.googleMaps.mapOptions = {
    mapTypeControl: false,
    scrollwheel: false,
    zoom: 16,
    mapTypeId: 'roadmap',
    styles: [
        {
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f5f5f5"
                }
            ]
        },
        {
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#e5e2df"
                }
            ]
        },
        {
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "color": "#f5f5f5"
                }
            ]
        },
        {
            "featureType": "administrative.land_parcel",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#bdbdbd"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#eeeeee"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#f2f0ef"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#757575"
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#e5e5e5"
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#9e9e9e"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#ffffff"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#757575"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#dadada"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#616161"
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#9e9e9e"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#f2f0ef"
                }
            ]
        },
        {
            "featureType": "transit.line",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#e5e5e5"
                }
            ]
        },
        {
            "featureType": "transit.station",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#eeeeee"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#c9c9c9"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#d1ccc7"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#9e9e9e"
                }
            ]
        }
    ]
};

/**
 * @link https://www.taniarascia.com/google-maps-apis-for-multiple-locations/ <-- don't
 * @link https://wrightshq.com/playground/placing-multiple-markers-on-a-google-map-using-api-3/
 */
he.googleMaps.init = function () {
    /*
     * ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
     * INIT MAP
     * ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
     */
    var bounds = new google.maps.LatLngBounds();

    // Display a map on the page
    this.map = new google.maps.Map(document.getElementById(this.mapHtmlElement), this.mapOptions);
    this.service = new google.maps.places.PlacesService(this.map);

    // store info window globally to close it manually on filter change
    this.infoWindow = new google.maps.InfoWindow();


    var marker;

    // Loop through our array of markers & place each one on the map
    this.placeIds.forEach(function (placeId) {
        he.googleMaps.service.getDetails({
            placeId: placeId
        }, function (place, status) {
            if (status === google.maps.places.PlacesServiceStatus.OK) {

                // set bounds
                bounds.extend(place.geometry.location);

                // init marker data
                markerData = {
                    position: place.geometry.location,
                    // add map, because we want to show them initially
                    map: he.googleMaps.map,
                    //title: locationData.title,
                    placeId: he.googleMaps.placeId,
                    location: place.geometry.location
                };

                // init marker
                marker = new google.maps.Marker(markerData);

                // Automatically center the map fitting all markers on the screen
                he.googleMaps.map.fitBounds(bounds);

                // add marker to array
                he.googleMaps.addMarkerToMarkersArray(marker);

                if ($(document.body).hasClass('dplus-post-locations')) {
                    he.googleMaps.map.setZoom(14);
                }
            }
        });
    });

    he.googleMaps.map.fitBounds(bounds);

    // Override our map zoom level once our fitBounds function runs (Make sure it only runs once)
    var boundsListener = google.maps.event.addListener(he.googleMaps.map, 'bounds_changed', function (event) {
        //this.setZoom(11);
        //google.maps.event.removeListener(boundsListener);
    });
};

/**
 * Adds a marker to the map and push to the array.
 *
 * @link https://developers.google.com/maps/documentation/javascript/examples/marker-remove
 */
he.googleMaps.addMarkerToMarkersArray = function (markerData) {
    this.markers.push(
        new google.maps.Marker(markerData)
    );
};